

export class CreateOrUpdateBonusDto implements ICreateOrUpdateBonusDto {
    id!: number | undefined;
    yearMonth!: string | undefined;
    bonusPercentage!: number;
    employeeId!: number;
    fromMonth!: string | undefined;
    toMonth!: string | undefined;
    bonusGross!: number;
    bonusAmount!: number;
    incentiveBonus!: number;
    totalBonus!: number;
    remark!: string | undefined;

    constructor(data?: ICreateOrUpdateBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yearMonth = _data["yearMonth"];
            this.bonusPercentage = _data["bonusPercentage"];
            this.employeeId = _data["employeeId"];
            this.fromMonth = _data["fromMonth"];
            this.toMonth = _data["toMonth"];
            this.bonusGross = _data["bonusGross"];
            this.bonusAmount = _data["bonusAmount"];
            this.incentiveBonus = _data["incentiveBonus"];
            this.totalBonus = _data["totalBonus"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreateOrUpdateBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yearMonth"] = this.yearMonth;
        data["bonusPercentage"] = this.bonusPercentage;
        data["employeeId"] = this.employeeId;
        data["fromMonth"] = this.fromMonth;
        data["toMonth"] = this.toMonth;
        data["bonusGross"] = this.bonusGross;
        data["bonusAmount"] = this.bonusAmount;
        data["incentiveBonus"] = this.incentiveBonus;
        data["totalBonus"] = this.totalBonus;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICreateOrUpdateBonusDto {
    id: number | undefined;
    yearMonth: string | undefined;
    bonusPercentage: number;
    employeeId: number;
    fromMonth: string | undefined;
    toMonth: string | undefined;
    bonusGross: number;
    bonusAmount: number;
    incentiveBonus: number;
    totalBonus: number;
    remark: string | undefined;
}

